import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-column align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_3 = { class: "field flex justify-content-center" }
const _hoisted_4 = { class: "field flex justify-content-center" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "col-12 md:col-6 lg:col-6 p-2" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "item-category" }, "Kategória", -1)
const _hoisted_9 = {
  key: 0,
  class: ""
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "item-product" }, "Produkt", -1)
const _hoisted_14 = { class: "flex align-items-center justify-content-between gap-1" }
const _hoisted_15 = {
  key: 0,
  class: ""
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "item-code" }, "Kód", -1)
const _hoisted_20 = { class: "flex justify-content-center" }
const _hoisted_21 = {
  key: 0,
  class: "image-container"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "image-container placeholder"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image placeholder-icon" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "col-12 md:col-6 lg:col-6 p-2" }
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "item-name" }, "Názov", -1)
const _hoisted_29 = { class: "field" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "item-length" }, "Dĺžka", -1)
const _hoisted_31 = { class: "field" }
const _hoisted_32 = {
  class: "flex align-items-center justify-content-between",
  style: {"margin-bottom":"0.45rem"}
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "" }, "Farba", -1)
const _hoisted_34 = { class: "flex align-items-center justify-content-right" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "imitation",
  class: "mr-2"
}, "Imitácia dreva", -1)
const _hoisted_36 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "flex align-items-center" }
const _hoisted_39 = { class: "field" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "item-type" }, "Poznámka", -1)
const _hoisted_41 = { class: "field" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "item-location" }, "Umiestnenie", -1)
const _hoisted_43 = { class: "w-12 grid ml-0 mr-0" }
const _hoisted_44 = { class: "col-4 pl-0 pr-1 pb-0" }
const _hoisted_45 = { class: "field mb-3" }
const _hoisted_46 = { class: "flex align-items-center justify-content-left" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: "wholePiece",
  class: "ml-2"
}, "Celý kus", -1)
const _hoisted_48 = {
  class: "field",
  style: {"margin-bottom":"1.14rem"}
}
const _hoisted_49 = { class: "flex align-items-center justify-content-left" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "reserved",
  class: "ml-2"
}, "Rezervovaný", -1)
const _hoisted_51 = { class: "col-8 pl-2 pb-0 pr-0" }
const _hoisted_52 = { class: "field mb-3" }
const _hoisted_53 = { class: "flex align-items-center justify-content-left" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  for: "readyToSpray",
  class: "ml-2"
}, "Pripravený na nastriekanie", -1)
const _hoisted_55 = {
  class: "field",
  style: {"margin-bottom":"1.14rem"}
}
const _hoisted_56 = { class: "flex align-items-center justify-content-left" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "sprayed",
  class: "ml-2"
}, "Nastriekaný", -1)
const _hoisted_58 = {
  class: "field",
  style: {"position":"relative"}
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { for: "item-order" }, "Objednávka", -1)
const _hoisted_60 = { key: 0 }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", {
  class: "flex justify-content-center align-items-center",
  style: {"width":"1.8rem"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "p-icon p-button-icon"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_62 = {
  key: 0,
  class: "card",
  style: {"z-index":"10","position":"absolute","top":"56px","left":"2px","min-width":"20rem","transform-origin":"center top","margin-top":"2px"}
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_64 = { class: "field" }
const _hoisted_65 = {
  class: "flex align-items-center justify-content-between",
  style: {"margin-bottom":"0.45rem"}
}
const _hoisted_66 = { class: "w-6 pr-2" }
const _hoisted_67 = {
  key: 0,
  class: "text-sm font-italic text-red-400"
}
const _hoisted_68 = { class: "w-6 flex justify-content-center" }
const _hoisted_69 = { class: "field flex justify-content-center" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_71 = { class: "mt-2 flex flex-wrap justify-content-center gap-3" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1)
const _hoisted_74 = { class: "grid" }
const _hoisted_75 = { class: "grid w-full h-full" }
const _hoisted_76 = { class: "col-6 p-2" }
const _hoisted_77 = { class: "text-left font-bold" }
const _hoisted_78 = { class: "text-left mt-5" }
const _hoisted_79 = { class: "col-6 p-1 flex justify-content-center" }
const _hoisted_80 = { class: "w-full h-full flex justify-content-center align-items-center" }
const _hoisted_81 = ["src", "onLoad"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!
  const _component_PrimevueTag = _resolveComponent("PrimevueTag")!
  const _component_PrimevueDialog = _resolveComponent("PrimevueDialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-10 lg:w-8 xl:w-8 mb-2" }, {
      title: _withCtx(() => [
        _createTextVNode("KUS")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/mod-stock/scan-item",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Skenovať QR kód",
                severity: "success",
                icon: "pi pi-camera",
                text: "",
                raised: "",
                class: "uppercase w-full"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_PrimevueButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.printLabel())),
            label: "Vytlač štítok",
            disabled: !(this.stockItem.id > 0),
            icon: "pi pi-print",
            severity: "success",
            text: "",
            raised: "",
            class: "w-full uppercase"
          }, null, 8, ["disabled"])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
          name: "itemForm"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_PrimevueSelect, {
                  id: "item-category",
                  modelValue: this.selectedCategory,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.selectedCategory) = $event)),
                  options: this.categories,
                  optionLabel: "name",
                  placeholder: "Vyber kategóriu",
                  class: _normalizeClass(["w-full", `${$setup.v$.selectedCategory.$error ? 'bg-red-200' : ''}`]),
                  invalid: $setup.v$.selectedCategory.$error,
                  onChange: _cache[2] || (_cache[2] = ($event: any) => ($options.filterProducts(this.selectedCategory.id)))
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "class", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedCategory.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_PrimevueSelect, {
                    id: "item-product",
                    disabled: !this.selectedCategory.name,
                    modelValue: this.selectedProduct,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.selectedProduct) = $event)),
                    options: this.products,
                    filter: "",
                    optionLabel: "code",
                    placeholder: "Vyber produkt",
                    class: _normalizeClass(["w-full", `${$setup.v$.selectedProduct.$error ? 'bg-red-200' : ''}`]),
                    invalid: $setup.v$.selectedProduct.$error,
                    onChange: _cache[4] || (_cache[4] = ($event: any) => ($options.selectProduct()))
                  }, {
                    value: _withCtx((slotProps) => [
                      (slotProps.value.id != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", null, _toDisplayString(slotProps.value.code) + " * " + _toDisplayString(slotProps.value.name.length > 31 ? slotProps.value.name.slice(0, 31) + '...' : slotProps.value.name), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.option.code) + " * " + _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue", "options", "class", "invalid"]),
                  _withDirectives(_createVNode(_component_PrimevueButton, {
                    type: "button",
                    class: "products",
                    icon: "pi pi-table",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (this.visibleProducts = true)),
                    text: "",
                    severity: "primary",
                    size: "large"
                  }, null, 512), [
                    [
                      _directive_tooltip,
                      { value: 'Zobrazenie a výber produktov' },
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedProduct.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  disabled: "",
                  modelValue: this.stockItem.code,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.stockItem.code) = $event)),
                  type: "text",
                  name: "item-code",
                  id: "item-code"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                (this.stockItem.product.image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("img", {
                        src: this.stockItem.product.image,
                        alt: "Preview Image",
                        class: "preview-image"
                      }, null, 8, _hoisted_22)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  disabled: "",
                  modelValue: this.stockItem.product.name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.stockItem.product.name) = $event)),
                  type: "text",
                  name: "item-name",
                  id: "item-name"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_InputNumber, {
                  class: "w-full",
                  inputId: "item-length",
                  useGrouping: false,
                  disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                  modelValue: this.stockItem.length,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.stockItem.length) = $event)),
                  name: "item-length",
                  id: "item-length",
                  inputClass: `${$setup.v$.stockItem.length.$error ? 'bg-red-200' : ''}`,
                  invalid: $setup.v$.stockItem.length.$error
                }, null, 8, ["disabled", "modelValue", "inputClass", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.stockItem.length.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_PrimevueCheckbox, {
                      modelValue: this.imitation,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.imitation) = $event)),
                      inputId: "imitation",
                      name: "imitation",
                      binary: true,
                      onChange: _cache[10] || (_cache[10] = ($event: any) => ($options.setColors()))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_PrimevueSelect, {
                  id: "item-color",
                  disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                  modelValue: this.selectedColor,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.selectedColor) = $event)),
                  options: this.colors,
                  optionLabel: "code",
                  placeholder: "Vyber farbu",
                  class: _normalizeClass(["w-full", `${$setup.v$.selectedColor.$error ? 'bg-red-200' : ''}`]),
                  invalid: $setup.v$.selectedColor.$error
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("div", {
                            class: "color-box mr-2",
                            style: _normalizeStyle({ backgroundColor: slotProps.value.colorHash })
                          }, null, 4),
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.code), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", {
                        class: "color-box mr-2",
                        style: _normalizeStyle({ backgroundColor: slotProps.option.colorHash })
                      }, null, 4),
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.code), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "options", "class", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedColor.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                  modelValue: this.stockItem.comment,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.stockItem.comment) = $event)),
                  type: "text",
                  name: "item-type",
                  id: "item-type"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                  modelValue: this.stockItem.location,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((this.stockItem.location) = $event)),
                  type: "text",
                  name: "item-location",
                  id: "item-location"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_PrimevueCheckbox, {
                        disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                        modelValue: this.stockItem.wholePiece,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((this.stockItem.wholePiece) = $event)),
                        inputId: "wholePiece",
                        name: "wholePiece",
                        binary: true
                      }, null, 8, ["disabled", "modelValue"]),
                      _hoisted_47
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_PrimevueCheckbox, {
                        disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                        modelValue: this.stockItem.reserved,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((this.stockItem.reserved) = $event)),
                        inputId: "reserved",
                        name: "reserved",
                        binary: true,
                        onChange: _cache[16] || (_cache[16] = ($event: any) => ($options.setReserved()))
                      }, null, 8, ["disabled", "modelValue"]),
                      _hoisted_50
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_PrimevueCheckbox, {
                        disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                        modelValue: this.stockItem.readyToSpray,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((this.stockItem.readyToSpray) = $event)),
                        inputId: "readyToSpray",
                        name: "readyToSpray",
                        binary: true
                      }, null, 8, ["disabled", "modelValue"]),
                      _hoisted_54
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_PrimevueCheckbox, {
                        disabled: !(this.selectedCategory.name && this.selectedProduct.code && this.stockItem.readyToSpray),
                        modelValue: this.stockItem.sprayed,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((this.stockItem.sprayed) = $event)),
                        inputId: "sprayed",
                        name: "sprayed",
                        binary: true
                      }, null, 8, ["disabled", "modelValue"]),
                      _hoisted_57
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createVNode(_component_PrimevueButton, {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (this.visibleSelect = !this.visibleSelect)),
                  disabled: !(this.selectedCategory.name && this.selectedProduct.code && this.stockItem.reserved),
                  label: "test",
                  style: {"height":"2rem"},
                  class: _normalizeClass(["flex justify-content-between w-full", `${$setup.v$.stockItem.order.$error ? 'bg-red-200' : ''}`]),
                  outlined: "",
                  invalid: $setup.v$.stockItem.order.$error,
                  id: "item-order"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      (this.stockItem.order.id > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                            _createElementVNode("span", null, _toDisplayString(this.stockItem.order.orderCode), 1),
                            _createTextVNode(" * "),
                            _createElementVNode("span", null, _toDisplayString(this.stockItem.order.customer.lastName), 1),
                            _createTextVNode(" * "),
                            _createElementVNode("span", null, _toDisplayString(this.stockItem.order.customer.city), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_61
                  ]),
                  _: 1
                }, 8, ["disabled", "class", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.stockItem.order.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128)),
                (this.visibleSelect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createVNode(_component_IconField, { iconPosition: "left" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputIcon, null, {
                            default: _withCtx(() => [
                              _hoisted_63
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_InputText, {
                            modelValue: $data.orderFilters['global'].value,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($data.orderFilters['global'].value) = $event)),
                            placeholder: "Vyhľadať",
                            onInput: $options.onOrderFilter
                          }, null, 8, ["modelValue", "onInput"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataTable, {
                        lazy: "",
                        paginator: "",
                        rows: this.selectParams.rows,
                        onPage: $options.onOrderPage,
                        first: this.selectParams.first,
                        loading: $data.selectLoading,
                        totalRecords: this.selectParams.totalRecords,
                        dataKey: "id",
                        value: this.orderOptions,
                        scrollHeight: `${200}px`,
                        virtualScrollerOptions: { itemSize: 40 },
                        stripedRows: "",
                        "row-hover": "",
                        scrollable: "",
                        selection: this.selectedOrder,
                        "onUpdate:selection": _cache[21] || (_cache[21] = ($event: any) => ((this.selectedOrder) = $event)),
                        selectionMode: "single",
                        metaKeySelection: false,
                        onRowSelect: _cache[22] || (_cache[22] = ($event: any) => ($options.selectOrder(this.selectedOrder))),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "ID",
                            field: "orderCode",
                            style: {"width":"5%"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Meno",
                            field: "customer.lastName",
                            style: {"width":"50%"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Obec",
                            field: "customer.city",
                            style: {"width":"45%"}
                          })
                        ]),
                        _: 1
                      }, 8, ["rows", "onPage", "first", "loading", "totalRecords", "value", "selection"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_InputNumber, {
                      inputId: "cut-length",
                      useGrouping: false,
                      disabled: !(this.stockItem.id > 0),
                      modelValue: this.cutLength,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((this.cutLength) = $event)),
                      name: "cut-length",
                      id: "cut-length",
                      inputClass: `${this.cutLengthIsWrong  ? 'bg-red-200 w-full h-2rem' : 'w-full h-2rem'}`,
                      invalid: this.cutLengthIsWrong,
                      placeholder: "Dĺžka odrez. kusa"
                    }, null, 8, ["disabled", "modelValue", "inputClass", "invalid"]),
                    (this.cutLengthIsWrong)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, " Chybná dĺžka odrezaného kusa "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_PrimevueButton, {
                      onClick: _cache[24] || (_cache[24] = ($event: any) => ($options.cutItem())),
                      label: "Odrež z kusa",
                      disabled: !(this.stockItem.id > 0),
                      style: {"padding-top":"0.42rem","padding-bottom":"0.324rem"},
                      severity: "success",
                      text: "",
                      raised: "",
                      class: "w-full uppercase"
                    }, null, 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_PrimevueButton, {
              onClick: _cache[25] || (_cache[25] = ($event: any) => ($options.eliminateItem())),
              label: "Vyraď kus",
              disabled: !(this.stockItem.id > 0),
              severity: "danger",
              text: "",
              raised: "",
              class: "w-full uppercase"
            }, null, 8, ["disabled"])
          ]),
          _hoisted_70,
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_PrimevueButton, {
              type: "submit",
              label: "Uložiť",
              text: "",
              raised: "",
              class: "uppercase"
            }),
            _createVNode(_component_router_link, { to: "/mod-stock/stock-items" }, {
              default: _withCtx(() => [
                _createVNode(_component_PrimevueButton, {
                  label: "Zrušiť",
                  severity: "danger",
                  text: "",
                  raised: "",
                  class: "uppercase"
                })
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    }),
    _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-10 lg:w-8 xl:w-8" }, {
      title: _withCtx(() => [
        _createTextVNode("Pohyby s kusom")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_72
      ]),
      content: _withCtx(() => [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.stockMovements, (history) => {
            return (_openBlock(), _createElementBlock("li", {
              key: history.id
            }, [
              _hoisted_73,
              _createTextVNode(" " + _toDisplayString($options.Utils.formatToSlovak(history.createdAt)) + " ", 1),
              _createVNode(_component_PrimevueTag, {
                class: "text-base",
                value: history.action,
                style: _normalizeStyle({ backgroundColor: history.color })
              }, null, 8, ["value", "style"]),
              _createTextVNode(" - " + _toDisplayString(history.user.firstName) + " " + _toDisplayString(history.user.lastName), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_PrimevueDialog, {
      visible: this.visibleProducts,
      "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((this.visibleProducts) = $event)),
      header: "Produkty",
      style: { width: '60rem' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.products, (prod, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "p-1 sm:col-12 md:col-4 lg:col-4 xl:col-4"
            }, [
              _createVNode(_component_PrimevueButton, {
                outlined: "",
                class: "p-1",
                onClick: ($event: any) => ($options.setSelectProduct(prod) ),
                onMouseover: ($event: any) => (this.hoverIndex = index),
                onMouseleave: _cache[27] || (_cache[27] = ($event: any) => (this.hoverIndex = null)),
                style: _normalizeStyle($options.buttonStyle(index))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, _toDisplayString(prod.code), 1),
                      _createElementVNode("div", _hoisted_78, _toDisplayString(prod.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("img", {
                          src: prod.image,
                          style: _normalizeStyle(`${prod.imageHeight >= prod.imageWidth ? 'height:168px;' : 'width:140px;'}`),
                          onLoad: ($event: any) => ($options.checkImageSize(index,$event)),
                          alt: "Preview Image",
                          class: ""
                        }, null, 44, _hoisted_81)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["onClick", "onMouseover", "style"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ConfirmDialog)
  ]))
}